export default {
    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getSearchFields: state => state.searchFields,
    getHeaderFields: state => state.headerFields
}
